export default[
    {
        path:'/index',
        name:'index',
        meta:{
            title:'Banco'
        },
        component:()=>import('@/baseloan/views/loan/index/index.vue')
    },
    {
        path:'/baseloan/bindcard',
        name:'bindcard',
        meta:{
            title:'Adición de la tarjeta bancaria'
        },
        component:()=>import('@/baseloan/views/loan/bindcard/index.vue')
    },
    {
        path:'/baseloan/bindcard/result/:orderStatus/:title/:desc',
        name:'result',
        meta:{
            title:'Comprobación de la aplicación'
        },
        component:()=>import('@/baseloan/views/loan/result/index.vue')
    },
    {
        path:'/order',
        name:'orderIndex',
        meta:{
            title:'Pedido de Cashplus'
        },
        component:()=>import('@/baseloan/views/order/index/index.vue')
    },
    {
        path:'/order/payment/spei',
        name:'paymentSpei',
        meta:{
            title:'SPEI Reembolso'
        },
        component:()=>import('@/baseloan/views/order/paySpei/index.vue')
    },
    {
        path:'/order/payment/oxxo',
        name:'paymentOxxo',
        meta:{
            title:'OXXO Reembolso'
        },
        component:()=>import('@/baseloan/views/order/payOxxo/index.vue')
    },
    //选择银行卡
    // {
    //     path:'/charge/cardlist',
    //     name:'cardlist',
    //     meta:{
    //         title:'Banco'
    //     },
    //     component:()=>import('@/cashplusapp/views/loan/CardList.vue')
    // },

]



// WEBPACK FOOTER //
// ./src/baseloan/router/router.js